export const PROGRAM_NAME_LIMIT = 100;

export const PROGRAMS_AND_LEARNING_LIMIT = 50;

export const PROGRAM_NAME_VALUE = 'programName';

export const DEFAULT_MODAL_WIDTH = 496;
